import styled, { css } from "styled-components";
import { BaseTextButton } from "./base.styles";
export const SeeMore = styled(BaseTextButton) `
    display: none;
    margin-top: 16px;
    padding: 0;
`;
const LINE_HEIGHT_MULTIPLIER = 1.3;
export const CollapsibleWrapper = styled.div `
    font-size: ${(props) => `${props.fontSize}${props.fontUnit}`};

    ${(props) => props.collapsed &&
    css `
            & > *:first-child {
                max-height: ${props.maxLinesVisible * props.fontSize * LINE_HEIGHT_MULTIPLIER}${props.fontUnit};
                overflow: hidden;
                padding-right: 1rem;
                position: relative;
            }
        `}

    ${(props) => props.overflowing &&
    css `
            cursor: pointer;

            & ${SeeMore} {
                display: block;
            }
        `}
`;
